import superagent from 'superagent';
import { backendUrl } from '@helpers/consts';


class TicketApi {
  constructor() {
    this.baseUrl = `${backendUrl}/tickets`;
  }

  getAuthHeaders() {
    return {
      'Authorization': `Bearer ${localStorage.getItem("authJWT")}`,
      'accept': 'json'
    };
  }

  // ==================== STATUS MAPPING APIs ====================

  /**
   * Get all status mappings
   * @returns {Promise<StatusMappingResponseDto[]>}
   */
  async getAllStatusMappings() {
    const response = await superagent
      .get(`${this.baseUrl}/status-mappings`)
      .set(this.getAuthHeaders());
    return response.body;
  }



  /**
   * Create new status mapping
   * @param {CreateStatusMappingDto} mapping
   * @returns {Promise<StatusMappingResponseDto>}
   */
  async createStatusMapping(mapping) {
    const response = await superagent
      .post(`${this.baseUrl}/status-mappings`)
      .send(mapping)
      .set(this.getAuthHeaders());
    return response.body;
  }

  /**
   * Update status mapping
   * @param {string} id
   * @param {UpdateStatusMappingDto} mapping
   * @returns {Promise<StatusMappingResponseDto>}
   */
  async updateStatusMapping(id, mapping) {
    const response = await superagent
      .put(`${this.baseUrl}/status-mappings/${id}`)
      .send(mapping)
      .set(this.getAuthHeaders());
    return response.body;
  }

  /**
   * Delete status mapping
   * @param {string} id
   * @returns {Promise<void>}
   */
  async deleteStatusMapping(id) {
    await superagent
      .delete(`${this.baseUrl}/status-mappings/${id}`)
      .set(this.getAuthHeaders());
  }



  // ==================== DASHBOARD APIs ====================

  /**
   * Get unified tickets with filtering and pagination
   * @param {Object} params - Query parameters
   * @returns {Promise<PaginatedTicketsResponseDto>}
   */
  async getTickets(params = {}) {
    
    const filters = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v !== false && v !== undefined)
    );

    const queryString = new URLSearchParams(filters).toString();
    const response = await superagent
      .get(`${this.baseUrl}/dashboard${queryString ? `?${queryString}` : ''}`)
      .set(this.getAuthHeaders());
    return response.body;
  }


  async getDashboardStatistics(filters = {}) {
  
    filters = Object.fromEntries(
      Object.entries(filters).filter(([_, v]) => v !== false && v !== undefined)
    );

  
    const queryString = new URLSearchParams(filters).toString();
    const response = await superagent
      .get(`${this.baseUrl}/dashboard/statistics${queryString ? `?${queryString}` : ''}`)
      .set(this.getAuthHeaders());
    return response.body;
  }



  /**
   * Export tickets data
   * @param {Object} params - Same as getTickets params
   * @returns {Promise<UnifiedTicketDto[]>}
   */
  async exportTickets(params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const response = await superagent
      .get(`${this.baseUrl}/dashboard/export${queryString ? `?${queryString}` : ''}`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  /**
   * Get available statuses for status mapping
   * @returns {Promise<{boards: Array}>}
   */
  async getAvailableStatuses() {
    const response = await superagent
      .get(`${this.baseUrl}/status-mappings/available-statuses`)
      .set(this.getAuthHeaders());
    return response.body;
  }

  
}

// Export singleton instance
export default new TicketApi();
